export default "__VITE_ASSET__BCIqVTqh__"